import { ApprovalRequest } from '@/modules/approvers/models/ApprovalRequest'
import formatRequestState from '../formatRequestState'
import dayjs from 'dayjs'
import { formatRequestType } from '../formatRequestType'
import * as XLSX from 'xlsx'

export const exportExcel = (filteredRequests: ApprovalRequest[]) => {
  const columns: string[] = [
    'Codigo Empleado',
    'Nombre Empleado',
    'Tipo solicitud',
    'Cantidad',
    'Fecha inicial',
    'Fecha final',
    'Estado',
    'Fecha Creacion',
    'Observacion',
    'Aprobados',
  ]

  if (!filteredRequests) {
    console.error('No filtered requests available')
    return
  }

  const requests = filteredRequests

  // Collect all dynamic columns for steps
  const dynamicColumns: Set<string> = new Set()

  const transformedData = requests.map((request: ApprovalRequest) => {
    const approverStepsColumns: any = {}

    request.RequestStepOutputDto?.forEach((step, index) => {
      if (step.useEmployeeSupervisor) {
        approverStepsColumns['Supervisor'] = request.employeeSupervisorName
        dynamicColumns.add('Supervisor')
      } else {
        const approverKey = `Aprobador ${index + 1}`
        approverStepsColumns[approverKey] = step.approver
          ? step.approver.name
          : '-'
        dynamicColumns.add(approverKey)
      }
      const stateKey = `Estado ${index + 1}`
      const dateKey = `Fecha resolucion ${index + 1}`
      approverStepsColumns[stateKey] = step.resolutionState
        ? formatRequestState(step.resolutionState)
        : '-'
      approverStepsColumns[dateKey] = step.resolutionDate
        ? dayjs(step.resolutionDate).format('DD/MM/YYYY HH:mm:ss')
        : '-'
      dynamicColumns.add(stateKey)
      dynamicColumns.add(dateKey)
    })

    return {
      'Codigo Empleado': request.employee.split('-')[0].trim(),
      'Nombre Empleado': request.employee.split('-')[1].trim(),
      'Tipo solicitud': formatRequestType(request.type),
      Estado: formatRequestState(request.globalStatus),
      Cantidad: request.quantity,
      'Fecha inicial': dayjs(request.dateInit).format('DD/MM/YYYY'),
      'Fecha final': dayjs(request.dateEnd).format('DD/MM/YYYY'),
      Observacion: request.observation,
      'Fecha Creacion': dayjs(request.createdAt).format('DD/MM/YYYY HH:mm:ss'),
      Aprobados: `${request.approvedCount} / ${request.approversCount}`,
      ...approverStepsColumns,
    }
  })

  if (transformedData.length === 0) {
    console.error('No data to transform')
    return
  }

  // Combine static columns and dynamic columns
  const finalColumns = [...columns, ...Array.from(dynamicColumns)]

  // Create worksheet data
  const worksheetData = [
    finalColumns,
    ...transformedData.map((row) => finalColumns.map((col) => row[col] || '')),
  ]

  const worksheet = XLSX.utils.aoa_to_sheet(worksheetData)
  const workbook = XLSX.utils.book_new()
  XLSX.utils.book_append_sheet(workbook, worksheet, 'FilteredData')
  const fileName = `reporte_de_solicitudes${dayjs().format('DD-MM-YYYY')}.xlsx`
  XLSX.writeFile(workbook, fileName)
}
